export const SELECTED_ACCOUNTS_COOKIE = 'selected_accounts';
